import React, { useContext } from 'react';
import { Navbar, Col, Row, Container } from 'react-bootstrap';
import RobotBox from '../layout/RobotBox';
import { OptionContext } from '../../contexts/OptionContext';
import ButtonInputType from '../layout/ButtonInputType';

const ButtonInput = ({ buttons = [] }) => {
  const optionContext = useContext(OptionContext);
  const { input } = optionContext;
  return (
    <div className="fixed-bottom mb-xl-4">
      <Container fluid="lg">
        <RobotBox background={input.background} fluid="lg" className="px-4 py-3 py-md-4 py-lg-6 align-items-end">
          <Col xs={12}>
            <Row className="justify-content-center align-items-center">
              {buttons.map((btn, i) => (
                <Col xs="12" md="4" className="mb-2" key={btn.text}>

                  <ButtonInputType block button={input.button} size="md" className={`px-0 px-lg-5 py-3 btn-min-lg ${btn.rounded ? 'btn-rounded' : ''}`}
                    variant="purple" key={`bot-btn-input-${btn.text + i} ${btn.disabled}`}
                    onClick={btn.onClick} disabled={btn.disabled}
                  >
                    {btn.text}
                  </ButtonInputType>
                  {btn.hint
                    && <h6 className="mt-2 text-center">{btn.hint}</h6>}

                </Col>
              ))}
            </Row>

          </Col>
        </RobotBox>
      </Container>
    </div>
  );
};

export default ButtonInput;
